// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MatchInfo_wrapper__g9O4s","title":"MatchInfo_title__A8flf","entries":"MatchInfo_entries__sQpi7","entry":"MatchInfo_entry__94sgy"};